import * as React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { styled } from '@mui/material/styles';

const PlaceholderArea = styled('div')(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main
}));

const IconWithMark = styled('span')({
    position: 'relative',
    display: 'inline-flex'
});

const SuccessMark = styled(CheckCircleIcon)(({ theme }) => ({
    position: 'absolute',
    right: '-2px',
    bottom: '2px',
    fontSize: 22,
    color: theme.palette.success.main,
    backgroundColor: '#fff',
    borderRadius: '50%'
}));

export function ImagePlaceholderContent() {
    return (
        <PlaceholderArea data-testid="image-placeholder" aria-hidden="true">
            <IconWithMark>
                <ImageOutlinedIcon
                    data-testid="image-placeholder-icon"
                    sx={{ fontSize: 64, color: '#fff' }}
                />
                <SuccessMark data-testid="image-placeholder-success" />
            </IconWithMark>
        </PlaceholderArea>
    );
}
